"use strict";
/* tslint:disable no-bitwise radix */
Object.defineProperty(exports, "__esModule", { value: true });
var XORCipher = {
    decode: function (key, data) {
        data = b64_decode(data);
        return xor_decrypt(key, data);
    }
};
var b64Table = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function b64_decode(data) {
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0;
    var result = [];
    if (!data) {
        return data;
    }
    data += "";
    do {
        h1 = b64Table.indexOf(data.charAt(i++));
        h2 = b64Table.indexOf(data.charAt(i++));
        h3 = b64Table.indexOf(data.charAt(i++));
        h4 = b64Table.indexOf(data.charAt(i++));
        bits = h1 << 18 | h2 << 12 | h3 << 6 | h4;
        o1 = bits >> 16 & 0xff;
        o2 = bits >> 8 & 0xff;
        o3 = bits & 0xff;
        result.push(o1);
        if (h3 !== 64) {
            result.push(o2);
            if (h4 !== 64) {
                result.push(o3);
            }
        }
    } while (i < data.length);
    return result;
}
function keyCharAt(key, i) {
    return key.charCodeAt(Math.floor(i % key.length));
}
function xor_decrypt(key, data) {
    return data.map(function (c, i) {
        return String.fromCharCode(c ^ keyCharAt(key, i));
    }).join("");
}
exports.default = (function (encrypted) {
    var decoded;
    try {
        var length_1 = parseInt(encrypted.substr(3, 2));
        decoded = JSON.parse(XORCipher.decode(encrypted.slice(5, length_1 + 5), encrypted.slice(5 + length_1)));
    }
    catch (e) {
        decoded = null;
    }
    return decoded;
});
